import mixpanel from 'mixpanel-browser';
import { useUser } from './useUser';
import { useEffect } from 'react';

const { NX_ENV, NX_MIXPANEL_TOKEN } = import.meta.env;

export const trackingEnvEnabled = NX_ENV !== 'staging';

const trackSessionCount = () => {
  const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
  const lastSession = parseInt(localStorage.getItem('last_session') ?? '0');
  const now = Date.now();
  const diff = now - lastSession;

  if (!lastSession || diff > SESSION_TIMEOUT) {
    mixpanel.people.increment('sessions_count', 1);
    localStorage.setItem('last_session', now.toString());
  }
};

export const useAnalytics = () => {
  const consentCookie = (window as any).Cookiebot?.consent;
  const { data: user } = useUser();

  if (trackingEnvEnabled) {
    mixpanel.init(NX_MIXPANEL_TOKEN, {
      debug: false,
      persistence: 'localStorage',
      api_host: 'https://api-eu.mixpanel.com',
      autocapture: {
        pageview: 'full-url',
        click: false,
        input: false,
        scroll: false,
        submit: true,
      },
      record_sessions_percent: 5,
      loaded: () => {
        if (consentCookie?.statistics === false && NX_ENV !== 'dev') {
          mixpanel.opt_out_tracking();
        }
      },
    });
  }

  useEffect(() => {
    if (trackingEnvEnabled && user?.completed) {
      mixpanel.identify(user?.auth0UserId);
      mixpanel.people.set({
        business_id: user?.businessId,
        business_name: user?.business?.name,
        signup_date: user?.createdAt,
        browser_locale: navigator.language,
        browser_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        subscription_tier: Object.values(user?.entitlements ?? {}).some(Boolean)
          ? 'paid'
          : 'free',
      });

      trackSessionCount();
    }
  }, [user]);
};
